<template>
  <div class="panel granary-panel">
    <div class="chart-box">
      <div class="tab-box flex">
        <div
          v-for="(item, index) in typeList"
          :key="index"
          class="tab-item"
          :class="{ active: active === index }"
          @click="changeType(index)"
        >
          <span>{{ item }}</span>
        </div>
      </div>
      <div ref="chart" class="chart"></div>
    </div>
  </div>
</template>

<script>
import { loadChart } from "./charts/scyzData";
import { findQueryList } from "@/api/granary";
import { timerMixin } from "@/util/mixin/timerMixin";
import { findIndexByName } from "@/util/index";
export default {
  mixins: [timerMixin],
  data() {
    return {
      typeList: ["产量", "养殖面积"],
      active: 0
    };
  },
  mounted() {
    this.getData();
    // this.startTimer();
  },
  methods: {
    runs() {
      let len = this.typeList.length;
      let active = Number(this.active);
      if (active < len - 1) {
        active++;
      } else {
        active = 0;
      }
      this.changeType(active, false);
    },
    changeType(index, clearT = true) {
      this.active = index;
      this.getData();
      if (clearT) {
        this.startTimer();
      }
    },
    getData() {
      this.chart = this.$echarts.init(this.$refs.chart);

      if (this.active === 0) {
        findQueryList({
          code: "yzqk_cl"
        }).then(res => {
          const data = res.data;
          if (data instanceof Array) {
            let sdata = [];
            data.forEach(ele => {
              const index = findIndexByName(ele.series, sdata, "series");
              if (~index) {
                sdata[index]["children"].push({
                  name: ele.name,
                  value: Number(ele.cl)
                });
                sdata[index]["value"] += Number(ele.cl);
              } else {
                sdata.push({
                  series: ele.series,
                  value: Number(ele.cl),
                  children: [
                    {
                      name: ele.name,
                      value: Number(ele.cl)
                    }
                  ]
                });
              }
            });
            //内圈数据
            let innerData = [];
            innerData = sdata.map(ele => {
              return {
                name: ele.series,
                value: ele.value
              };
            });

            //外圈数据
            let outerData = [];
            sdata.forEach(ele => {
              ele.children.forEach(item => {
                outerData.push(item);
              });
            });
            const name = this.typeList[this.active];
            const unit = "吨";
            loadChart(this.chart, innerData, outerData, name, unit);
          }
        });
        // const sData = [
        //   {
        //     name: "海洋捕捞",
        //     value: 126090,
        //     children: [
        //       {
        //         name: "鱼类",
        //         value: 105245
        //       },
        //       {
        //         name: "甲壳类",
        //         value: 9824
        //       },
        //       {
        //         name: "贝类",
        //         value: 1884
        //       },
        //       {
        //         name: "藻类",
        //         value: 750
        //       },
        //       {
        //         name: "头足类",
        //         value: 5485
        //       },
        //       {
        //         name: "其它",
        //         value: 2902
        //       }
        //     ]
        //   },
        //   {
        //     name: "海水养殖",
        //     value: 475530,
        //     children: [
        //       {
        //         name: "鱼类",
        //         value: 73309
        //       },
        //       {
        //         name: "甲壳类",
        //         value: 71274
        //       },
        //       {
        //         name: "贝类",
        //         value: 318222
        //       },
        //       {
        //         name: "藻类",
        //         value: 12725
        //       }
        //     ]
        //   },
        //   {
        //     name: "淡水捕捞",
        //     value: 2708,
        //     children: [
        //       {
        //         name: "鱼类",
        //         value: 1937
        //       },
        //       {
        //         name: "甲壳类",
        //         value: 115
        //       },
        //       {
        //         name: "贝类",
        //         value: 564
        //       },
        //       {
        //         name: "其它",
        //         value: 92
        //       }
        //     ]
        //   },
        //   {
        //     name: "淡水养殖",
        //     value: 317841,
        //     children: [
        //       {
        //         name: "鱼类",
        //         value: 308723
        //       },
        //       {
        //         name: "甲壳类",
        //         value: 7025
        //       },
        //       {
        //         name: "贝类",
        //         value: 1871
        //       },
        //       {
        //         name: "其它",
        //         value: 222
        //       }
        //     ]
        //   }
        // ];
        // //内圈数据
        // let innerData = [];
        // innerData = sData.map(ele => {
        //   return {
        //     name: ele.name,
        //     value: ele.value
        //   };
        // });

        // //外圈数据
        // let outerData = [];
        // sData.forEach(ele => {
        //   ele.children.forEach(item => {
        //     outerData.push(item);
        //   });
        // });
        // const name = this.typeList[this.active];
        // const unit = "吨";
        // loadChart(this.chart, innerData, outerData, name, unit);
      } else {
        findQueryList({
          code: "yzqk_mj"
        }).then(res => {
          const data = res.data;
          if (data instanceof Array) {
            let sdata = [];
            data.forEach(ele => {
              const index = findIndexByName(ele.series, sdata, "series");
              if (~index) {
                sdata[index]["children"].push({
                  name: ele.name,
                  value: Number(ele.area)
                });
                sdata[index]["value"] += Number(ele.area);
              } else {
                sdata.push({
                  series: ele.series,
                  value: Number(ele.area),
                  children: [
                    {
                      name: ele.name,
                      value: Number(ele.area)
                    }
                  ]
                });
              }
            });

            //内圈数据
            let innerData = [];
            innerData = sdata.map(ele => {
              return {
                name: ele.series,
                value: ele.value
              };
            });

            //外圈数据
            let outerData = [];
            sdata.forEach(ele => {
              ele.children.forEach(item => {
                outerData.push(item);
              });
            });
            const name = this.typeList[this.active];
            const unit = "公顷";
            loadChart(this.chart, innerData, outerData, name, unit);
          }
        });
        // const sData = [
        //   {
        //     name: "海水养殖",
        //     value: 14579,
        //     children: [
        //       {
        //         name: "鱼类",
        //         value: 2636
        //       },
        //       {
        //         name: "甲壳类",
        //         value: 3847
        //       },
        //       {
        //         name: "贝类",
        //         value: 8037
        //       },
        //       {
        //         name: "藻类",
        //         value: 59
        //       }
        //     ]
        //   },
        //   {
        //     name: "淡水养殖",
        //     value: 22918.82,
        //     children: [
        //       {
        //         name: "池塘",
        //         value: 16067.82
        //       },
        //       {
        //         name: "水库",
        //         value: 6721
        //       },
        //       {
        //         name: "其它",
        //         value: 130
        //       }
        //     ]
        //   }
        // ];
        // //内圈数据
        // let innerData = [];
        // innerData = sData.map(ele => {
        //   return {
        //     name: ele.name,
        //     value: ele.value
        //   };
        // });

        // //外圈数据
        // let outerData = [];
        // sData.forEach(ele => {
        //   ele.children.forEach(item => {
        //     outerData.push(item);
        //   });
        // });
        // const name = this.typeList[this.active];
        // const unit = "公顷";
        // loadChart(this.chart, innerData, outerData, name, unit);
      }

      window.addEventListener("resize", () => {
        setTimeout(() => {
          this.chart.resize();
        }, 300);
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.panel
  height 100%
  width 100%
  .chart-box
    width 100%
    height 100%
    position relative
    .tab-box
      position absolute
      top 10px
      right 4%
      z-index 999
      .tab-item
        color #fff
        font-size 10px
        padding-left 13px
        margin-right 20px
        position relative
        cursor pointer
        &:before
          content ' '
          // width 6px
          // height 6px
          width 12px
          height 12px
          border-radius 50%
          background #fff
          position absolute
          left 0
          top 50%
          transform translateY(-50%)
      .active
        color #0e9cff
        &:before
          background #0e9cff
</style>
